import { api } from "../api";

export default async function upsertWalletDataB3(
  formData: FormData
): Promise<number> {
  try {
    const response = await api.post("/user/wallet/b3", formData);

    return response.status;
  } catch (err: any) {
    console.log(err);

    return err?.response?.status;
  }
}
